import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteItems } from "../../redux/actions/actionItem";
import Swal from "sweetalert2";


export default function PreciosModCard({ id, idItem, name, stock, stockTotal, description, value, onPriceChange }) {

  const dispatch = useDispatch();
  const [price, setPrice] = useState();
  
  const handlePrice = (e) => {
    let newPrice = e.target.value;
    console.log(newPrice);
    if (newPrice === "" || Number.isNaN(newPrice)) {
      newPrice = value;
      Swal.fire("Debe ingresar un precio válido");
    }         
    setPrice(newPrice);
    onPriceChange(id, newPrice);
  };
  
  return (
    <div className="border-b border-slate-500">
        
      <div className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400">
        <div className="border-slate-500 w-12">
          <p className="text-center">{idItem}</p>
        </div>
        <div className="border-slate-500 w-60">
          <p className="">{name}</p>
        </div>
        <div className="border-slate-500 w-6/12">
          <p className="">{description}</p>
        </div>
        <div className="border-slate-500 w-14 text-center">
          <p className="">{stock}</p>
        </div>
        <div className="border-slate-500 w-14 text-center">
          <p className="">{stockTotal}</p>
        </div>        
        <div className="border-slate-500 w-28 text-center border">
          <input
            type="number"
            className="bg-slate-500 text-orange-600 placeholder-orange-400 placeholder:text-center text-center"
            placeholder={value}
            onChange={handlePrice}
          />
        </div>
      </div>
       
    </div>
  );
}

/*
function PrecioModCard({ item, onPriceChange }) {
  const [price, setPrice] = useState(item.price);

  const handleChange = (e) => {
    const newPrice = e.target.value;
    setPrice(newPrice);
    onPriceChange(item._id, newPrice);
  };

  return (
    <div>
      <h3>{item.name}</h3>
      <input value={price} onChange={handleChange} />
    </div>
  );
}
*/



